import { getParameterByName } from "../helpers/getParameter";
import { priceWrapper } from "../offer-table/priceWrapper";
var helpSearchApp = document.querySelector("#help-search-app");

var mainSearch = document.querySelector("#mainSearch");
Vue.component("search-input", {
	delimiters: ["{[{", "}]}"],
	// props: ['searchinputcon', 'disabledsubmitcon', 'showlinkscon', 'fastlinkscon', 'promptscon'],
	props: [
		"datasearchredirect",
		"dataprompturl",
		"datasearchurl",
		"indexsearch",
		"indexprompt",
		"dataonstart",
		"placeholder",
		"fastlinkelements",
		"type",
		"alwaysredirect",
		"fastlinkstext",
		"promptstext",
		"srsearch",
		"srdescription",
		"buttonid"
	],
	data: function() {
		return {
			helpSearchApp: "",
			searchInput: "",
			disabledSubmit: true,
			showlinks: false,
			fastlinks: true,
			prompts: "",
			promptUrl: "",
			dataMethod: "",
			index_prompt: "",

			searchText: "",
			counter: 0,
			results: "",
			pages: 0,
			showResults: false,
			searchUrl: "",
			dataRedirect: "",
			onStart: "",
			index_search: "",
			myTimeout: ""
		};
	},
	mounted: function() {
		this.helpSearchApp = this.$refs.helpSearchApp;
		this.promptUrl = this.helpSearchApp.getAttribute("data-prompt-url");
		this.dataMethod = this.helpSearchApp.getAttribute("data-method");
		this.searchUrl = this.helpSearchApp.getAttribute("data-search-url");
		this.dataRedirect = this.helpSearchApp.getAttribute("data-search-redirect");
		this.onStart = this.helpSearchApp.getAttribute("data-onstart");

		// if (helpSearchApp) {
		// 	if (helpSearchApp.getAttribute('data-search-redirect') === '') {
		// 		this.dataRedirect = helpSearchApp.getAttribute('data-search-redirect');
		// 	}
		// }

		this.index_prompt = this.$refs.index_prompt.value;
		this.index_search = this.$refs.index_search.value;

		const pagePar = parseInt(getParameterByName("page"));
		if (getParameterByName("search")) {
			if (getParameterByName("type") == this.type && this.onStart != "no") {
				this.searchInput = getParameterByName("search");
				this.onSubmit(pagePar, true);
			}
		}
		let that = this;
		$(document).click(function(event) {
			if (
				event.target.id !== "searchHelp" &&
				event.target.id !== "searchHelp-help" &&
				event.target.id !== "searchHelp-main"
			) {
				that.showlinks = false;
			}
		});
	},
	updated: function() {
		if (this.searchInput.length > 0) {
			this.disabledSubmit = false;
		}
	},
	methods: {
		showLinks: function(event) {
			console.log("this.searchInput.length", this.searchInput.length);
			console.log("this.fastlinks", this.fastlinks);
			if (this.searchInput.length > 2) {
				this.fastlinks = false;
				this.showPrompt(event);
			}
			if (this.searchInput.length === 0 || this.searchInput.length > 2) {
				this.showlinks = true;
			}
		},
		hideLinks: function(event) {
			this.showlinks = false;
			event.stopPropagation();
		},
		showPrompt: function(event) {
			console.log("document.activeElement", document.activeElement);
			if (event.target === document.activeElement) {
				this.searchInput = event.target.value;
				this.showlinks = true;
			}
			const that = this;
			if (this.searchInput.length > 0) {
				this.disabledSubmit = false;
			} else {
				this.disabledSubmit = true;
			}
			if (this.searchInput.length > 2) {
				this.fastlinks = false;
				const that = this;
				const xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						that.prompts = JSON.parse(this.responseText);
					} else if (this.readyState == 4 && this.status != 200) {
					}
				};
				xhttp.open(this.dataMethod, this.promptUrl);
				xhttp.setRequestHeader("Content-Type", "application/json");
				clearTimeout(this.myTimeout);
				this.myTimeout = setTimeout(function() {
					xhttp.send(
						JSON.stringify({
							search: that.searchInput,
							index: that.index_prompt
						})
					);
				}, 500);
			} else {
				this.fastlinks = true;
			}
		},
		onSubmit: function(pagenumber, nohistory) {
			const elem = this.$refs.searchInput;
			elem.blur();
			// console.log('onSubmit', this.dataRedirect, 'this.onStart=', this.onStart, 'this.type=', this.type);
			if (
				this.alwaysredirect == "true" ||
				(this.dataRedirect && this.onStart != "no")
			) {
				window.location.href =
					this.dataRedirect +
					"?search=" +
					encodeURIComponent(this.searchInput) +
					"&type=" +
					this.type +
					"&page=" +
					pagenumber;
			} else {
				this.onStart = "";
				// console.log('submit');
				const that = this;

				const xhttp = new XMLHttpRequest();
				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {
						that.results = JSON.parse(this.responseText);
						that.pages = that.results.pages;
						that.counter = that.results.results_count;
						that.showResults = true;
						that.searchText = that.searchInput;
						if (pagenumber >= that.pages) {
							pagenumber = 0;
						}
						if (!nohistory) {
							history.pushState(
								null,
								null,
								"?search=" +
									encodeURIComponent(that.searchInput) +
									"&type=" +
									that.type +
									"&page=" +
									pagenumber
							);
						}
						for (let result in that.results.results) {
							for (let subject in that.results.results[result].subjects) {
								let sub = that.results.results[result].subjects[subject];
								let regEx = new RegExp(`(${that.searchText})`, "gi");
								sub.description = String(sub.description).replace(
									regEx,
									"<strong>$1</strong>"
								);

								// that.counter++;
							}
						}
						that.$emit("send-form", {
							showResults: that.showResults,
							results: that.results,
							searchText: that.searchText,
							counter: that.counter,
							page: pagenumber
						});
						that.$root.showLoader = false;
					} else if (this.readyState == 4 && this.status != 200) {
						that.$root.showLoader = false;
					}
				};
				that.$root.showLoader = true;
				xhttp.open(this.dataMethod, this.searchUrl);
				xhttp.setRequestHeader("Content-Type", "application/json");
				// console.log({'search': this.searchInput, 'index': this.index_search, 'page': pagenumber });
				xhttp.send(
					JSON.stringify({
						search: this.searchInput,
						index: this.index_search,
						page: pagenumber
					})
				);
			}
		}
	},
	template: "#search-input-template"
});

Vue.component("search-results", {
	delimiters: ["{[{", "}]}"],
	props: [
		"showresultscon",
		"resultscon",
		"searchtextcon",
		"countercon",
		"resultstext1",
		"resultstext2",
		"resultstext3",
		"noresultstext",
		"noresultstext2",
		"result_title"
	],
	data: function() {
		return {
			page: 0
		};
	},
	updated: function() {
		const pagePar = parseInt(getParameterByName("page"));
		this.page = pagePar;
		// console.log('activePage', this.page);
	},
	methods: {
		pageClicked: function(page) {
			this.page = page;
			this.$emit("change-page", {
				page: this.page
			});
			document.querySelector(".search-results__container").focus();
		},
		prevPage: function() {
			this.page = this.page - 1;
			this.$emit("change-page", {
				page: this.page
			});
			document.querySelector(".search-results__container").focus();
		},
		nextPage: function() {
			this.page = this.page + 1;
			this.$emit("change-page", {
				page: this.page
			});
			document.querySelector(".search-results__container").focus();
		}
	},
	template: "#search-results-template"
});

Vue.component("search-wrapper", {
	delimiters: ["{[{", "}]}"],
	props: [],
	data: function() {
		return {
			showResults: false,
			results: "",
			searchText: "",
			counter: 0,
			page: 0
		};
	},
	updated: function() {
		priceWrapper();
	},
	methods: {
		sendForm: function(data) {
			// console.log('sendForm');
			this.showResults = data.showResults;
			this.results = data.results;
			this.searchText = data.searchText;
			this.counter = data.counter;
			this.page = data.page;
		},
		changePage: function(data) {
			this.page = data.page;
			this.$children[0].onSubmit(this.page);
			// console.log('this.$refs', this.$refs);
		}
	},
	template: "#search-template"
});

// if (helpSearchApp) {
// 	var app = new Vue({
// 		el: '#help-search-app',
// 		delimiters: ['{[{', '}]}'],
// 		data: {
// 			showResults: false,
// 			results: '',
// 			searchText: '',
// 			counter: 0,
// 			page: 0
// 		},
// 		created: function () {

// 		},
// 		mounted: function () {

// 		},
// 		methods: {
// 			sendForm: function (data) {
// 				this.showResults = data.showResults;
// 				this.results = data.results;
// 				this.searchText = data.searchText;
// 				this.counter = data.counter;
// 				this.page = data.page;
// 			},
// 			changePage: function (data) {
// 				this.page = data.page;
// 				this.$refs.helpSearch.onSubmit(this.page);
// 			}
// 		}
// 	});
// }
// if (mainSearch) {
// 	var app = new Vue({
// 		el: '#mainSearch',
// 		delimiters: ['{[{', '}]}'],
// 		data: {
// 			showlinks: true,
// 			showResults: false,
// 			results: '',
// 			searchText: '',
// 			counter: 0,
// 			page: 0
// 		},
// 		created: function () {

// 		},
// 		mounted: function () {

// 		},
// 		methods: {
// 			showLinks: function () {
// 				this.showlinks = true;
// 			},
// 			sendForm: function (data) {
// 				this.showResults = data.showResults;
// 				this.results = data.results;
// 				this.searchText = data.searchText;
// 				this.counter = data.counter;
// 				this.page = data.page;
// 			},
// 			changePage: function (data) {
// 				this.page = data.page;
// 				this.$refs.helpSearch.onSubmit(this.page);
// 			}
// 		}
// 	});
// }

// export const helpSearch = {

//     init: function (){

//         const inputValue = document.querySelector('input[type="text"]');
//         const result = document.querySelector('.help-search__list');
//         if ( !inputValue ) return;
//         if( !result ) return;

//         inputValue.addEventListener("focus", _ => {
//             result.classList.add('help-search--is-visible');
//         }, false);

//         inputValue.addEventListener("blur", _ => {
//             result.classList.remove('help-search--is-visible');
//         }, false);

//         inputValue.addEventListener("keydown", (e) => {

//             doKeypress(e);

//         }, false);

//         function doKeypress(e) {
//             var keyCode = e.keyCode;

//             switch (keyCode) {

//                 case 27:
//                     result.classList.remove('help-search--is-visible');
//                     break;

//                 default:
// 			        return;
// 	        }
//         }

//     }
// };
